import { render, staticRenderFns } from "./AddMail.vue?vue&type=template&id=a64079c8&scoped=true"
import script from "./AddMail.vue?vue&type=script&lang=js"
export * from "./AddMail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a64079c8",
  null
  
)

export default component.exports